import PropTypes from 'prop-types'
import { Navigate, Outlet } from 'react-router-dom'
import { useIsAdmin } from '../../redux/slices/session'

export default function AdminRoute({
  path = '/',
  children = undefined
}) {
  const isAdmin = useIsAdmin()

  if (!isAdmin) {
    return <Navigate from={path} to="/" />
  }

  return children || <Outlet />
}

AdminRoute.propTypes = {
  path: PropTypes.string,
  children: PropTypes.node,
}

